import { SelectableBillingPeriodTypes } from '@constants/billingPeriods'
import { CurrencyType, PLN } from '@constants/currencies'
import { PROMOTION_FOR_FREE_PLAN } from '@hooks/useSale'
import { useGetPromotions } from '@pages/Checkout/hooks/useGetPromotions'
import { Discount } from '@services/discounts'
import { FC } from 'react'

import { PromotionForFreePlan } from './components/Promotions'
import { RegularPrice } from './components/RegularPrice'

interface PriceLabelProps {
  currency: CurrencyType
  price: number
  billingPeriod: SelectableBillingPeriodTypes
  annualSavingPrice: number
  isFreePlan?: boolean
  discount?: Discount
}

export const PriceLabel: FC<PriceLabelProps> = ({
  currency,
  price,
  billingPeriod,
  annualSavingPrice,
  isFreePlan,
  discount
}) => {
  const promotions = useGetPromotions({
    price,
    billingPeriod
  })

  const isPLNCurrency = currency === PLN

  if (
    promotions[PROMOTION_FOR_FREE_PLAN].isVisible &&
    promotions[PROMOTION_FOR_FREE_PLAN].price &&
    !isFreePlan
  ) {
    return (
      <PromotionForFreePlan
        regularPrice={price}
        price={promotions[PROMOTION_FOR_FREE_PLAN].price}
        currency={currency}
        isPLNCurrency={isPLNCurrency}
      />
    )
  }

  // TODO: Black Friday promotion
  // if (
  //   promotions[BLACK_FRIDAY].isVisible &&
  //   promotions[PROMOTION_FOR_FREE_PLAN].price &&
  //   !isFreePlan
  // ) {
  //   return null
  // }

  return (
    <RegularPrice
      currency={currency}
      price={price}
      billingPeriod={billingPeriod}
      annualSavingPrice={annualSavingPrice}
      isPLNCurrency={isPLNCurrency}
      isFreePlan={isFreePlan}
      discount={discount}
    />
  )
}

PriceLabel.displayName = 'CheckoutPlansPlanPanelsPlanPriceLabel'
